import gql from 'graphql-tag';

export default gql`
query ($id: String!) {
  getProvider (id: $id) {
    __typename
    id
    name
    externalFields
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Providers/GetQuery.js